/**
 * Generated by android-app/build-release.js - do not edit by hand.
 *
 * Shown in the app so the build actually running on a handset can be read off
 * the screen rather than assumed.
 */
export const BUILD_VERSION = '1.0.4';
export const BUILD_NUMBER = 4;
export const BUILT_AT = '2026-08-29T09:01:27.489Z';

export default { BUILD_VERSION, BUILD_NUMBER, BUILT_AT };
